import { render } from "./PageWorldItems.vue?vue&type=template&id=ae75ab96&scoped=true"
import script from "./PageWorldItems.vue?vue&type=script&lang=js"
export * from "./PageWorldItems.vue?vue&type=script&lang=js"

import "./PageWorldItems.vue?vue&type=style&index=0&id=ae75ab96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae75ab96"]])

export default __exports__